"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoutFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Button_1 = require("../../atoms/Button");
var RightHandDrawer_1 = require("../../molecules/RightHandDrawer");
var Checklist_1 = require("../../molecules/Checklist");
var styles_1 = __importDefault(require("./styles"));
exports.PopoutFilter = react_1.default.memo(function (_a) {
    var sortOptions = _a.sortOptions, filterOptions = _a.filterOptions, _b = _a.onSortChange, onSortChange = _b === void 0 ? function () { } : _b, _c = _a.onFilterChange, onFilterChange = _c === void 0 ? function () { } : _c, _d = _a.onClear, onClear = _d === void 0 ? function () { } : _d, _e = _a.onApply, onApply = _e === void 0 ? function () { } : _e, kicker = _a.kicker, children = _a.children, rest = __rest(_a, ["sortOptions", "filterOptions", "onSortChange", "onFilterChange", "onClear", "onApply", "kicker", "children"]);
    var classes = (0, styles_1.default)();
    var PopoutControls = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", justifyContent: "space-between", className: classes.footer }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "PopoutFilterClearButton", className: classes.clear, onClick: onClear, variant: "text" }, { children: "Clear selections" })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "PopoutFilterApplyButton", className: classes.apply, onClick: onApply, variant: "text" }, { children: "Apply" }))] }))); });
    return ((0, jsx_runtime_1.jsxs)(RightHandDrawer_1.RightHandDrawer, __assign({ title: "Sort & Filter", controls: (0, jsx_runtime_1.jsx)(PopoutControls, {}), role: "menu" }, rest, { children: [kicker || null, sortOptions && ((0, jsx_runtime_1.jsx)(Checklist_1.Checklist, { onChange: onSortChange, options: [
                    { legend: "Sort By", multiple: false, options: sortOptions },
                ] })), filterOptions && ((0, jsx_runtime_1.jsx)(Checklist_1.Checklist, { onChange: onFilterChange, options: filterOptions })), children] })));
});
